import { ComponentEvents } from '../../../../global/interfaces/component.interface';

export const OrganismShoppingCartEvents: ComponentEvents = {
	postRender: 'postRender',
	/** The custom event emitted when a product is added to the cart */
	addToCart: 'addToCart',
};
